import { connect } from 'react-redux';
import { State } from 'store/types';

import { isEligible } from 'store/app/selector';
import View from './View';

const mapStateToProps = (state: State) => {
  const { appReducer, remoteConfig, dataLayer } = state;
  return {
    device: appReducer.client.device,
    topNavConfig: remoteConfig.configs.topNavConfig,
    isStickyHeader: isEligible(
      remoteConfig.configs?.AB?.stickyHeader,
      appReducer.run
    ),
    pageType: dataLayer?.pageType,
  };
};

export default connect(mapStateToProps)(View);
